import { render, staticRenderFns } from "./BasePriceList.vue?vue&type=template&id=16c5d16e&scoped=true"
import script from "./BasePriceList.vue?vue&type=script&lang=js"
export * from "./BasePriceList.vue?vue&type=script&lang=js"
import style0 from "./BasePriceList.vue?vue&type=style&index=0&id=16c5d16e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c5d16e",
  null
  
)

export default component.exports